import React, { useEffect } from "react";
import { COLORS, Typo } from "../../../../../layout/theme";
import { Container, LinkButton, Section } from "./styles";
import AddProducts from "../add-products/AddProducts";
import { AntdButton } from "../../styles";
import { FaTruckPickup } from "react-icons/fa";
import { InfoCircleOutlined, InfoOutlined } from "@ant-design/icons";

export default function ProductsToCartStep({
	clientInfo,
	templateProducts,
	setTemplateProducts,
	orderTemplate,
	user,
	selectedClient,
	clientId,
	step,
	handleOrderToCart,
	expoSelected,
	handleBack,
	handleBackToDistributorStep,
}) {
	return (
		<Section>
			<Container>
				<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
					<Typo type="primary" level={6}>
						Productos del pedido para farmacia{" "}
						<Typo type="secondary" level={6}>
							{clientInfo?.clientName}
						</Typo>
					</Typo>
					{/* <LinkButton
						type="link"
						color="white"
						bg="Secondary"
						onClick={handleBackToDistributorStep}
					>
						<InfoCircleOutlined style={{ color: COLORS.Secondary }} />
						<Typo type="secondary">Ver droguerías asociadas</Typo>
					</LinkButton> */}
				</div>
				<div style={{ display: "flex", gap: 10 }}>
					{step === 4 && templateProducts && templateProducts.length > 0 && (
						<AntdButton
							color={COLORS.Danger}
							backgroundColor={COLORS.White}
							borderColor={COLORS.DarkGrey}
							hoverColor={COLORS.Danger}
							onClick={handleBack}
						>
							Volver sin enviar
						</AntdButton>
					)}
					{step === 4 && templateProducts && templateProducts.length > 0 && (
						<AntdButton
							color={COLORS.Secondary}
							backgroundColor={COLORS.White}
							borderColor={COLORS.Secondary}
							hoverColor={COLORS.Secondary}
							onClick={handleBackToDistributorStep}
						>
							<InfoCircleOutlined style={{ color: COLORS.Secondary }} /> Ver
							droguerías asociadas
						</AntdButton>
					)}
					{step === 4 &&
						templateProducts &&
						templateProducts.length > 0 &&
						templateProducts.findIndex((p) => p.quantity !== 0) > -1 && (
							<AntdButton onClick={handleOrderToCart}>
								Enviar pedido al carro
							</AntdButton>
						)}
				</div>
			</Container>
			<AddProducts
				templateProducts={templateProducts}
				setTemplateProducts={setTemplateProducts}
				orderTemplate={orderTemplate}
				userId={user.uid}
				clientId={selectedClient}
				laboratoryId={clientId}
				expoSelected={expoSelected}
			/>
		</Section>
	);
}
